import { Inject, Injectable } from "@angular/core";

import { IConfig } from "@shared/interfaces";
import { APP_CONFIG } from "@shared/tokens";
import { CommonUtils } from "@shared/utils";

@Injectable({
  providedIn: "root",
})
export class GoogleTagManagerService {
  constructor(@Inject(APP_CONFIG) private environment: IConfig) {}

  init() {
    if (!this.environment.googleTagManagerId) {
      return;
    }
    this.addGTM();
  }

  private addGTM() {
    (window as any).dataLayer = (window as any).dataLayer || [];

    this.addGTMScript();
    this.addGTMIframe();
  }

  private addGTMScript() {
    CommonUtils.loadScripts([
      {
        innerHTML: `
      (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
      new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
      j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
      'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
      })(window,document,'script','dataLayer','${this.environment.googleTagManagerId}');
    `,
      },
    ]);
  }

  private addGTMIframe() {
    const noscript = document.createElement("noscript");

    const iframe = document.createElement("iframe");

    iframe.src = `https://www.googletagmanager.com/ns.html?id=${this.environment.googleTagManagerId}`;
    iframe.height = "0";
    iframe.width = "0";
    iframe.style.display = "none";
    iframe.style.visibility = "hidden";

    noscript.appendChild(iframe);

    const bodyElement = document.body;

    bodyElement.insertBefore(noscript, bodyElement.firstChild);
  }
}
